import moment from 'moment'

let thisWeekDateRange = {
  start: moment().startOf('week').startOf('day').toDate(),
  end: moment().endOf('week').startOf('day').toDate()
}

const PRESET_RANGES = {
  today (label) {
    return function () {
      const n = new Date()
      const startToday = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0)
      const endToday = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 23, 59)
      return {
        label: label || 'Danes',
        active: false,
        dateRange: {
          start: startToday,
          end: endToday
        }
      }
    }
  },
  thisWeek (label) {
    return function () {
      const n = new Date()
      const startMonth = new Date(n.getFullYear(), n.getMonth(), 2)
      const endMonth = new Date(n.getFullYear(), n.getMonth() + 1, 1)
      return {
        label: label || 'Ta teden',
        active: true,
        dateRange: thisWeekDateRange
      }
    }
  },
  thisMonth (label) {
    return function () {
      const n = new Date()
      const startMonth = new Date(n.getFullYear(), n.getMonth(), 2)
      const endMonth = new Date(n.getFullYear(), n.getMonth() + 1, 1)
      return {
        label: label || 'Ta mesec',
        active: true,
        dateRange: {
          start: startMonth,
          end: endMonth
        }
      }
    }
  },
  lastMonth (label) {
    return function () {
      const n = new Date()
      const startMonth = new Date(n.getFullYear(), n.getMonth() - 1, 2)
      const endMonth = new Date(n.getFullYear(), n.getMonth(), 1)
      return {
        label: label || 'Prejšnji mesec',
        active: false,
        dateRange: {
          start: startMonth,
          end: endMonth
        }
      }
    }
  },
  last7days (label) {
    return function () {
      const n = new Date()
      const start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 5)
      const end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1)
      return {
        label: label || 'Zadnjih 7 dni',
        active: false,
        dateRange: {
          start: start,
          end: end
        }
      }
    }
  },
  last30days (label) {
    return function () {
      const n = new Date()
      const start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 29)
      const end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1)
      return {
        label: label || 'Zadnjih 30 dni',
        active: false,
        dateRange: {
          start: start,
          end: end
        }
      }
    }
  }
}

export default {

  /**
   * Generates presets for daterange picker
   * @param {Array} presets Requested presets
   * @returns {Object} Object of preset functions
   */
  generate (presets = [], labels = {}) {
    let rtr = {}
    for (let p of presets) {
      rtr[p] = PRESET_RANGES[p](labels[p])
    }

    return rtr
  }
}


// WEBPACK FOOTER //
// ./src/assets/modules/inputs/dateRangePresetGenerator.js